import { useState } from 'react'

import type { ReactElement, ReactNode } from 'react'
import type { ISwitchButton } from '~/components/Buttons/SwitchButton'
import type { IAppMauProgression } from '~/types/okr'

import TableRow from '../TableRow'

import BlockTitle from '~/components/Blocks/Title'
import SwitchButton, { getDefaultDeviceTypeSwitchButtons } from '~/components/Buttons/SwitchButton'
import GridItemLayout from '~/components/GridItemLayout'

import './styles.scss'

interface Props {
  appsData?: {
    [key: string]: IAppMauProgression[]
  }
  title: ReactNode
}

const VariationTable = ({ apps, isIncrease }: { apps: IAppMauProgression[]; isIncrease?: boolean }): ReactElement => {
  return (
    <div className="table-wrapper">
      <div className="table-header">
        <div className="header-title">{isIncrease ? 'Highest' : 'Lowest'} contributors</div>
      </div>
      {apps.map(({ app_icon_url, app_id, app_key, device_type, mau, mau_diff, mau_progression, name }) => (
        <TableRow
          appIcon={app_icon_url}
          appId={app_id}
          appKey={app_key}
          appName={name || app_key}
          deviceType={device_type}
          key={app_key}
          mau={mau}
          mauDiff={mau_diff}
          mauProgression={mau_progression * 100}
          platform={device_type}
          type="small"
        />
      ))}
    </div>
  )
}

const Top10Block = ({ appsData, title }: Props): ReactElement => {
  const getHighestContributors = (apps: IAppMauProgression[] = []) => apps.slice(0, 5)

  const getLowestContributors = (apps: IAppMauProgression[] = []) => apps.slice(6, 11)

  const [switchButtons, setSwitchButtons] = useState<ISwitchButton[]>(
    getDefaultDeviceTypeSwitchButtons({ withWeb: false })
  )

  const [increasingApps, setIncreasingApps] = useState<IAppMauProgression[]>(getHighestContributors(appsData?.ios))

  const [decreasingApps, setDecreasingApps] = useState<IAppMauProgression[]>(getLowestContributors(appsData?.ios))

  const handleSwitchButtonSelectionChange = (buttonId: string) => {
    const selectedButton = switchButtons.find(({ id }) => id === buttonId)

    setSwitchButtons(
      switchButtons.map((button) => ({
        ...button,
        isActive: button.id === buttonId,
      }))
    )

    if (appsData && selectedButton?.id) {
      setIncreasingApps(getHighestContributors(appsData[selectedButton.id]))
      setDecreasingApps(getLowestContributors(appsData[selectedButton.id]))
    }
  }

  return (
    <GridItemLayout className="top-10-block-component">
      <div className="title-wrapper">
        <BlockTitle>{title}</BlockTitle>
        <SwitchButton
          buttons={switchButtons}
          onButtonSelectionChange={handleSwitchButtonSelectionChange}
          size="small"
        />
      </div>
      <VariationTable apps={increasingApps} isIncrease />
      <VariationTable apps={decreasingApps} />
    </GridItemLayout>
  )
}

export default Top10Block
